import { useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import FormNavigationMenu from 'features/Work/components/FormNavigationMenu';
import FormSection from 'features/Work/components/FormSection';

import locales from './locales';
import Sections from './Sections';
import * as S from './styles';

const navItems = [
  { title: locales.general, urlHash: '#general' },
  { title: locales.items, urlHash: '#items' },
  { title: locales.options, urlHash: '#options' },
];

const QuoteForm = () => {
  const history = useHistory();

  const [toHash, setToHash] = useState('');

  const { hash: currentHash } = useLocation();

  const handleVisibilityChange = (hash: string) => (isVisible: boolean) => {
    if (currentHash === '') {
      setToHash('#general');
      history.replace('#general');
      return;
    }

    if (toHash === hash) {
      setToHash('');
      return;
    }

    if (toHash === '' && isVisible) {
      history.replace(hash);
    }
  };

  return (
    <div>
      <FormNavigationMenu items={navItems} onNavigation={setToHash} />

      <S.Form>
        <FormSection
          anchor="general"
          backgroundColor="yellow"
          color="orange"
          icon="file"
          marginTop="-56px" // fix alignment of the first section
          onVisibilityChange={handleVisibilityChange('#general')}
          title={locales.general}
        >
          <Sections.General />
        </FormSection>

        <FormSection
          anchor="items"
          backgroundColor="lightBlue"
          color="lightBlue"
          icon="avatar-list"
          onVisibilityChange={handleVisibilityChange('#items')}
          title={locales.items}
        >
          <Sections.Tasks />
        </FormSection>

        <FormSection
          anchor="options"
          backgroundColor="grey"
          color="grey"
          icon="settings"
          onVisibilityChange={handleVisibilityChange('#options')}
          title={locales.options}
        >
          <Sections.Options />
        </FormSection>
      </S.Form>
    </div>
  );
};

export default QuoteForm;
